import React from "react";
import {
  FaArrowLeft,
  FaCommentDots,
  FaHeart,
  FaLock,
} from "react-icons/fa";

type AuthPageFrameProps = {
  backLabel: string;
  children: React.ReactNode;
  onBack: () => void;
};

export default function AuthPageFrame({
  backLabel,
  children,
  onBack,
}: AuthPageFrameProps) {
  return (
    <div className="auth-page">
      <AuthShowcase />

      <main className="auth-panel">
        <button type="button" className="auth-back-button" onClick={onBack}>
          <FaArrowLeft />
          <span>{backLabel}</span>
        </button>

        <div className="auth-form-wrap">
          <img
            className="auth-mobile-logo"
            src="/images/logo.png"
            alt="OneTop"
          />
          {children}
        </div>

        <AuthFooter />
      </main>
    </div>
  );
}

function AuthShowcase() {
  return (
    <aside className="auth-showcase" aria-label="OneTop donate preview">
      <div className="auth-brand">
        <img src="/images/logo.png" alt="OneTop" />
      </div>

      <div className="auth-preview">
        <img src="/images/onetop-auth-hero.png" alt="OneTop donate dashboard" />
        <div className="auth-preview-card auth-preview-card-left">
          <FaCommentDots />
          <div>
            <strong>OBS overlay</strong>
            <span>Connected</span>
          </div>
        </div>
        <div className="auth-preview-card auth-preview-card-right">
          <FaHeart />
          <div>
            <strong>ສ້າງລິ້ງຮັບເງິນ</strong>
            <span>Onetop.com/Yourname</span>
          </div>
        </div>
      </div>

      <div className="auth-showcase-copy">
        <p className="auth-donation-name">@kira_ttv ໄດ້ສົ່ງ</p>
        <p className="auth-donation-amount">₭100,000</p>
        <h2>ເຮັດໃຫ້ທຸກໂດເນດນ່າຈືຈຳ</h2>
        <p>ເລີ່ມງ່າຍ ບໍ່ຫຍຸ້ງຍາກ ຮັບບໍລິຈາກໄດ້ງ່າຍໆ</p>
      </div>
    </aside>
  );
}

function AuthFooter() {
  return (
    <footer className="auth-footer">
      <span>© 2026 OneTop Labs, Inc.</span>
      <nav>
        <button type="button">
          <FaLock />
          <span>ເງື່ອນໄຂການໃຊ້</span>
        </button>
        <a href="/policy">ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ</a>
        <button type="button" className="auth-contact-button">
          ຕິດຕໍ່ສອບຖາມ
        </button>
      </nav>
    </footer>
  );
}
